// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { ArrowUpRight } from "lucide-react";

export default function GoogleButton({ label = "Continue with Google", testid = "google-login" }) {
  const startGoogleAuth = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <button
      type="button"
      onClick={startGoogleAuth}
      data-testid={testid}
      className="w-full inline-flex items-center justify-center gap-3 border border-neutral-200 hover:border-gold hover:text-gold transition px-5 py-3 text-sm uppercase tracking-[0.18em]"
    >
      <GoogleMark />
      <span>{label}</span>
      <ArrowUpRight size={14} className="opacity-60" />
    </button>
  );
}

function GoogleMark() {
  return (
    <svg width="16" height="16" viewBox="0 0 48 48" aria-hidden="true">
      <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.9 32.4 29.4 35.5 24 35.5c-6.4 0-11.5-5.1-11.5-11.5S17.6 12.5 24 12.5c2.9 0 5.5 1.1 7.5 2.9l5.7-5.7C33.6 6.3 29.1 4.5 24 4.5 13.2 4.5 4.5 13.2 4.5 24S13.2 43.5 24 43.5 43.5 34.8 43.5 24c0-1.2-.1-2.3-.3-3.5z"/>
      <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16 19 12.5 24 12.5c2.9 0 5.5 1.1 7.5 2.9l5.7-5.7C33.6 6.3 29.1 4.5 24 4.5 16.5 4.5 9.9 8.6 6.3 14.7z"/>
      <path fill="#4CAF50" d="M24 43.5c5 0 9.5-1.7 13-4.6l-6-5.1c-1.9 1.3-4.3 2.1-7 2.1-5.3 0-9.8-3-11.5-7.3l-6.6 5.1C9.7 39.4 16.3 43.5 24 43.5z"/>
      <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.7 2.1-2.1 3.9-3.9 5.2l6 5.1c-.4.4 6.6-4.8 6.6-14.3 0-1.2-.1-2.3-.4-3.5z"/>
    </svg>
  );
}
